import React, { useEffect } from 'react';
import { getUrlParam } from 'libs/helper/utils';
import { useStoreWrapper } from 'stores/StoreHelper';
import { useLocation } from 'react-router-dom';
import VoucherFilter from 'components/management/filters/VoucherFilter';
import VouchersTable from 'components/management/tables/VouchersTable';
import { AdminVoucherDto } from 'services/data-contracts';
import VoucherView from 'components/management/modals/VoucherView';
import VoucherEdit from 'components/management/modals/VoucheEdit';
import { observer } from 'mobx-react-lite';
import NoContents from 'components/commons/\bNoContents';

const VoucherPage = observer(() => {
  const { voucherFilterStore, uiStore } = useStoreWrapper();

  const voucherCategory = getUrlParam('voucherCategory');
  const location = useLocation();

  const fetchVouchers = () => {
    const search = getUrlParam('searchKeyword');
    const page = getUrlParam('page');
    const size = getUrlParam('size');
    const status = getUrlParam('status');

    if (voucherCategory) {
      voucherFilterStore.getVouchers(parseInt(voucherCategory), {
        keyword: search || '',
        page: page ? parseInt(page) : undefined,
        size: size ? parseInt(size) : 20,
        status: status ? status as 'OPEN' | 'USED' | 'EXPIRED' | undefined : undefined,
      });
    }
  }

  const handleRowClick = (voucher: AdminVoucherDto) => {
    uiStore?.modal.show({
      title: '바우처 상세',
      style: {
        maxWidth: '800px',
        height: 'auto',
        maxHeight: '80vh',
      },
      children: (
        <VoucherView
          voucher={voucher}

          // listings=
        />
      ),
    });
  };

  const handleEditClick = (voucher?: AdminVoucherDto) => {
    uiStore?.modal.show({
      title: '바우처 그룹 수정',
      style: {
        maxWidth: '800px',
        height: '100%',
        maxHeight: '80vh',
      },
      children: <VoucherEdit voucher={voucher} categoryId={voucherCategory ? parseInt(voucherCategory) : undefined} />,
      onConfirmed: () => {
        fetchVouchers();
      },
    });
  };

  useEffect(() => {
    fetchVouchers();
  }, [location.search]);

  return (
    <div>
      <VoucherFilter onClickAdd={() => { handleEditClick() }} />
      <VouchersTable
        vouchers={voucherFilterStore?.filteredVouchers}
        onRowClick={handleRowClick}
        onEditClick={handleEditClick}
      />
      <NoContents>
        표시할 데이터가 없습니다.
      </NoContents>
    </div>
  );
});

export default VoucherPage;
